import React, { useEffect } from 'react';
import { Layout, Notification, LoadingGif } from 'components';

import CheckBorderIcon from '../../assests/icons/check-border.icon';
import RejectBorderIcon from '../../assests/icons/rejected-border.icon';
import InfoBorderNotification from '../../assests/icons/info-border-notification.icon';

const OrderSuccessful = () => {
  useEffect(() => {
    Notification(
      "bottomLeft",
      "Tcell",
      'notification notification--success',
      'için ünvan başvurunuz başarıyla sonuçlandı',
      'success',
      <CheckBorderIcon />)
    Notification(
      "bottomLeft",
      "Tcell",
      'notification notification--info',
      'dosyasından seçtiğiniz  kayıtlar alıcı listesine eklendi.',
      'info',
      <InfoBorderNotification />)
    Notification(
      "bottomLeft",
      "Tcell",
      'notification notification--error',
      'dosyasından seçtiğiniz  kayıtlar alıcı listesine eklenemedi.',
      'error',
      <RejectBorderIcon />)
  } )

  return (
    <Layout>
      <div className='notification-boxes-wrapper'>
        <LoadingGif />
      </div>
    </Layout>
  );
};

export default OrderSuccessful;
